var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgForm = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M43.7 14.856 32.132 13.23a4.586 4.586 0 0 0-5.171 3.897l-1.262 8.977-6.75 48.027c-.52 3.701 2.105 7.184 5.806 7.704l37.108 5.216c3.701.52 7.184-2.105 7.705-5.806l1.144-8.144 2.731-19.432L77.58 24.24a4.586 4.586 0 0 0-3.897-5.171l-11.475-1.613"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M43.7 14.856 32.132 13.23a4.586 4.586 0 0 0-5.171 3.897l-1.262 8.977-6.75 48.027c-.52 3.701 2.105 7.184 5.806 7.704l37.108 5.216c3.701.52 7.184-2.105 7.705-5.806l1.144-8.144 2.731-19.433 4.136-29.427a4.586 4.586 0 0 0-3.897-5.171l-11.475-1.613"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m61.622 21.621 11.567 1.626a.402.402 0 0 1 .318.422l-4.512 32.11-2.914 20.73-.572 4.07a2.612 2.612 0 0 1-2.955 2.228l-37.2-5.228a2.612 2.612 0 0 1-2.227-2.956l6.75-48.027c.09-.648.46-1.256 1-1.747l7.599-5.726c.528-.398 1.215-.584 1.955-.48l2.59.364"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m61.622 21.621 11.567 1.626a.402.402 0 0 1 .318.422l-4.512 32.11-2.914 20.73-.572 4.07a2.612 2.612 0 0 1-2.955 2.228l-37.2-5.228a2.612 2.612 0 0 1-2.227-2.956l6.75-48.027c.09-.648.46-1.256 1-1.747l7.599-5.726c.528-.398 1.215-.584 1.955-.48l2.59.364"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "m30.435 26.556 7.358.115c.555.078 1.175-.307 1.266-.955l.886-6.475"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m30.435 26.556 7.358.115c.555.078 1.175-.307 1.266-.955l.886-6.475M36.234 33.058l28.132 3.953M34.557 44.995l21.376 3.004M35.389 39.072l28.132 3.954M38.795 55.121l11.475 1.613M33.243 54.341l1.296.182M37.118 67.059l11.197 1.573M31.566 66.279l1.11.156M38.043 61.15l11.382 1.6M32.398 60.356l1.018.143"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m60.76 14.328-3.24-.455.091-.648a2.313 2.313 0 0 0-1.988-2.638l-3.886-.547a2.313 2.313 0 0 0-2.639 1.989l-.091.648-3.239-.456a1.875 1.875 0 0 0-2.11 1.591l-.794 5.645a1.874 1.874 0 0 0 1.59 2.11l14.9 2.095a1.874 1.874 0 0 0 2.11-1.591l.793-5.645c.236-1.005-.48-1.955-1.498-2.098Z"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m48.86 17.752 7.588 1.066"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m72.661 58.56-8.021 6.045c-.422.318-.885.253-1.203-.17l-2.863-3.799c-.319-.422-.781-.487-1.203-.169l-3.483 2.625c-.422.318-.487.78-.17 1.203l5.727 7.599c.716.95 2.011 1.132 2.869.403L76.24 63.31c.422-.319.487-.781.17-1.203l-2.625-3.483c-.239-.317-.702-.382-1.124-.064Z"
  }));
};
export default SvgForm;